import { VApp } from 'vuetify/lib/components/VApp';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VSheet } from 'vuetify/lib/components/VSheet';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    VApp,
    [
      _c(
        VSheet,
        {
          staticClass: "favourite-btn d-flex align-center justify-center",
          attrs: {
            height: _vm.flat ? undefined : 32,
            width: _vm.flat ? undefined : _vm.url ? 72 : 32,
            elevation: _vm.flat ? undefined : 1,
            color: _vm.flat ? undefined : "white",
          },
        },
        [
          _vm.loading
            ? _c(VProgressCircular, {
                class: { "align-end": _vm.flat },
                attrs: {
                  size: 20,
                  width: "2",
                  color: "primary",
                  indeterminate: "",
                },
              })
            : _c("span", {
                staticClass: "ui-icon-fz-medium",
                class: _vm.favouriteIconClass,
                on: { click: _vm.handleFavouriteClick },
              }),
          _vm._v(" "),
          _vm.url
            ? _c("span", {
                staticClass:
                  "ui-icon-share-circle ui-icon-fz-medium text-info--text",
                class: _vm.flat ? "ml-2" : "ml-3",
                on: { click: _vm.handleShareClick },
              })
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }